/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { DenseMatrixDependencies } from './dependenciesDenseMatrixClass.generated.js';
import { matrixDependencies } from './dependenciesMatrix.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createLargerEq } from '../../factoriesAny.js';
export var largerEqDependencies = {
  DenseMatrixDependencies,
  matrixDependencies,
  typedDependencies,
  createLargerEq
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesLargerEq.generated.js
// module id = 264
// module chunks = 2